import { render, staticRenderFns } from "./CrowdxAboutCrowdedHero.vue?vue&type=template&id=b8e6920c"
import script from "./CrowdxAboutCrowdedHero.vue?vue&type=script&lang=js"
export * from "./CrowdxAboutCrowdedHero.vue?vue&type=script&lang=js"
import style0 from "./CrowdxAboutCrowdedHero.vue?vue&type=style&index=0&id=b8e6920c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports